import {
  GET_LANDING_PAGES_REQUEST,
  GET_LANDING_PAGES_SUCCESS,
  GET_LANDING_PAGES_FAILED,
  DELETE_LANDING_PAGE_REQUEST,
  DELETE_LANDING_PAGE_SUCCESS,
  DELETE_LANDING_PAGE_FAILED,
} from './actionTypes';

const initialState = {
  data: [],
  page: 1,
  lastPage: 1,
  loading: false,
  error: null,
  search: '',
  sort: null,
  order: null,
  perPage: 10,
};

const landingPagesReducer = (state = initialState, {
  type, error, data, meta, deletedId,
}) => {
  switch (type) {
    case GET_LANDING_PAGES_REQUEST:
      return { ...state, loading: true };
    case GET_LANDING_PAGES_SUCCESS:
      return {
        ...state,
        data,
        search: meta.search,
        page: meta.current_page,
        lastPage: meta.last_page,
        perPage: meta.per_page,
        order: meta.order,
        sort: meta.sort,
        loading: false,
      };
    case GET_LANDING_PAGES_FAILED:
      return { ...state, loading: false, error };
    case DELETE_LANDING_PAGE_REQUEST:
      return { ...state, loading: true };
    case DELETE_LANDING_PAGE_SUCCESS:
      return {
        ...state,
        data: state.data.filter((landing) => landing.id !== deletedId),
        loading: false,
      };
    case DELETE_LANDING_PAGE_FAILED:
      return { ...state, loading: false, error };
    default:
      return state;
  }
};

export default landingPagesReducer;
